import * as React from 'react';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { Routes, Route, RouteProps, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import Lazyload from '@shared/components/LazyLoad';

import styles from './Public.styles';
import SHARED_ROUTES from '@shared/constants/routes';

const Login = React.lazy(() => import('./submodules/Login'));
const Singin = React.lazy(() => import('./submodules/Singin'));

interface PublicProps extends WithStyles<typeof styles> {
  routes?: Array<RouteProps>;
}

@observer
class Public extends React.Component<PublicProps> {
  get routes(): Array<RouteProps> {
    const { login, singingOidc } = SHARED_ROUTES.public;

    return [
      { path: singingOidc, element: <Singin /> },
      { path: login, element: <Login /> },
    ];
  }

  private get modules() {
    return (
      <Lazyload>
        <Routes>
          {this.props.routes?.map((routeProps) => (
            <Route key={String(routeProps.path)} {...routeProps} />
          ))}

          {this.routes.map((routeProps) => (
            <Route key={String(routeProps.path)} {...routeProps} />
          ))}
          <Route path="*" element={<Navigate to={SHARED_ROUTES.public.login} replace />} />
        </Routes>
      </Lazyload>
    );
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <div className={classes.modules}>{this.modules}</div>
      </div>
    );
  }
}

export default withStyles(styles)(Public);
